import { useSelector } from 'react-redux'
import { PROJECT_MAX_DURATION, TIMELINE_RULER_SLICE_WIDTH } from 'consts'
import { editorSelectors } from 'store/features/editor/selectors'

const useTimelineMaxWidth = () => {
  const timelineSliceDuration = useSelector(
    editorSelectors.timelineRulerSliceDuration
  )

  return (
    (PROJECT_MAX_DURATION / timelineSliceDuration) * TIMELINE_RULER_SLICE_WIDTH
  )
}

export default useTimelineMaxWidth
